export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            关于星空
          </h2>
          <p className="text-sm text-foreground-500 mb-8">
            高速加载 · 秒开即播 · 超清画质
          </p>

          <div className="bg-background-100/80 rounded-lg p-6 md:p-8 border border-background-200/50">
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed text-left">
              星空电影网诞生于对极致观影体验的追求。我们深知等待缓冲是每个影迷的痛点，
              因此从底层技术架构出发，自研智能预加载引擎与全球加速网络，
              实现了真正意义上的不缓冲秒开播放。平台汇聚超过12,000部高清电影资源，
              从好莱坞巨制到华语佳作、从欧洲艺术片到日韩热门剧集，
              涵盖动作、科幻、悬疑、喜剧、爱情、纪录片等全品类内容。
              无需注册、无需付费，打开网页即可畅享超清画质的高速流畅观影体验。
              我们的播放引擎持续迭代优化，播放成功率保持在99.7%以上，
              致力于让每一位影迷在任何网络环境下都能即点即播，告别等待。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}